// extracted by mini-css-extract-plugin
export default {"container":"_1WX-f","divider":"aU-F-"};